import { render, staticRenderFns } from "./ListCategory.vue?vue&type=template&id=be9554e0&scoped=true"
import script from "./ListCategory.vue?vue&type=script&lang=js"
export * from "./ListCategory.vue?vue&type=script&lang=js"
import style0 from "./ListCategory.vue?vue&type=style&index=0&id=be9554e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be9554e0",
  null
  
)

export default component.exports